import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'

type DeleteMachineLocationDialogProps = {
  isOpen: boolean
  locationName: string
  onClose: () => void
  onConfirm: () => void
  isDeleting: boolean
}

export function DeleteMachineLocationDialog({
  isOpen,
  locationName,
  onClose,
  onConfirm,
  isDeleting,
}: DeleteMachineLocationDialogProps) {
  const { t } = useTranslation('machineryDirectiveCompliance')

  return (
    <Dialog
      open={isOpen}
      onOpenChange={(open) => {
        if (!open && !isDeleting) {
          onClose()
        }
      }}
    >
      <DialogContent showCloseButton={!isDeleting}>
        <DialogHeader>
          <DialogTitle>
            {t('machineLocationsPage.deleteDialog.title')}
          </DialogTitle>
        </DialogHeader>
        <p className='text-sm text-muted-foreground'>
          {t('machineLocationsPage.deleteDialog.description', {
            name: locationName,
          })}
        </p>
        <DialogFooter>
          <Button variant='outline' onClick={onClose} disabled={isDeleting}>
            {t('machineLocationsPage.cancel')}
          </Button>
          <Button
            variant='destructive'
            onClick={onConfirm}
            disabled={isDeleting}
          >
            {isDeleting
              ? t('machineLocationsPage.deleteDialog.deleting')
              : t('machineLocationsPage.deleteDialog.confirm')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
